import {Type} from "class-transformer";
import {serializeType} from "./common";
import {ContractClin} from "./contract-clin";
import {FeeSchedule} from "./fee-schedule";

import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {RevenueRecognitionLevel} from "@app/shared/enums/revenue-recognition-level.enum";
import {RevenueRecognitionType} from "@app/shared/enums/revenue-recognition-type.enum";
import {BillingType} from "@app/shared/enums/billing-type.enum";
import {BusinessSectorType} from "@app/shared/enums/business-sector-type.enum";
import {BillingLevelType, RevenueType, Transaction} from "@app/shared";

export enum OptionFundingAttributeName {
  Cost = "Cost",
  Fee = "Fee",
  TandM = 'TandM',
  FixedPrice = 'FixedPrice'
}

export class ContractOptionFunding {
  id: number;
  version: number;
  name: string;
  description?: string;
  awardedCostPlus?: number;
  awardedFee?: number;
  awardedTandM?: number;
  awardedFixedPrice?: number;
  awardedPrepaids?: number;
  fundedCostPlus?: number;
  fundedFee?: number;
  fundedTandM?: number;
  fundedFixedPrice?: number;
  fundedPrepaids?: number;
  contractModId?: number;
  contractOptionId?: number;
  // statusId: number;
  modNumber?: string;
}

export class ContractMilestone {
  id: number;
  version: number;
  name: string;
  description: string;
  sequenceNum: number;
  dueDateType?: DueDateType;
  daysFromStart?: string;
  plannedDueDate?: string;
  actualDeliveryDate?: string;
  contractId: number;
  contractModId?: number;
  contractOptionId?: number;
  contractOption?: ContractOption;
  // statusId: number;
  modNumber: string;
}

export class ContractSla {
  id: number;
  version: number;
  name: string;
  financialIncentive?: number;
  financialPenalty?: number;
  contractModId?: number;
  description: string;
  metricCalculation: string;
  slaMetricType: string;
  reportingPeriodType: string;
  contractId: number;
  // statusId: number;
  modNumber: string;
}


export class ContractComment {

}

export class ContractAccountSetting {

}


export class ContractModification {
  id: number;
  version: number;
  modType: string;
  modImpactType: string;
  modNumber: string;
  description: string;
  effectiveOn: string;
  contactId: number;
  pdfTemplateId?: number;
  projectId?: number;
  // purchaseOrderId?: number;
  customerModPONumber: string;
  contractId: number;
  statusName?: string;
  currentStatusName?: ApprovalStatusType = ApprovalStatusType.NotAvailable;
  hasSubmissionError?: boolean;
  projectName?: string;
  // purchaseOrderNumber?: string;
  contactFullName?: string;
  internalMod?: boolean = false;
}

export enum ModChangeType {
  AddMod = 'Add Mod',
  SubmitMod = 'Submit Mod',
  EditMod = 'Update Mod'
}


export enum ContractModTypeName {
  ContractSla = 'CONTRACTSLA',
  ContractMilestone = 'CONTRACTMILESTONE',
  ContractLaborCategory = 'CONTRACTLABORCATEGORY',
  ContractOption = 'CONTRACTOPTION',
  ContractClin = 'CONTRACTCLIN',
  ContractOptionFunding = 'CONTRACTOPTIONFUNDING',
  ContractClinFunding = 'CONTRACTCLINFUNDING',
  ContractBillingPlan = 'CONTRACTBILLINGPLAN',
  ContractGenInfo = 'ABSTRACTCONTRACT',
  BidRate = 'BIDRATE'
}

export class ContractOption {
  id: number;
  version: number;
  description: string;
  // @Type(serializeType(Date)) popFrom: Date;
  // @Type(serializeType(Date)) popThru: Date;
  popFrom: string;
  popThru: string;
  optionPeriod: string;
  @Type(serializeType(ContractClin)) contractClins?: ContractClin[];
  @Type(serializeType(ContractOptionFunding)) optionFundings?: ContractOptionFunding[];
  contractId: number;
  contractModId?: number;
  // statusId: number;
  modNumber?: string;
  //Transient
  hasDifferentBillingLevels?: boolean;
}

export class InternalContact {
  id: number;
  version: number;
  contactType: string;
  locationId: number;
  employeeId: number;
  contractId?: number;
  projectId?: number;
  estimateId?: number;
  subtype: string;
  addrName?: string;
  fullName?: string;
}

export class ContractLaborRate {
  id: number;
  version: number;
  yearIndex: string;
  effectiveFrom: string;
  effectiveThru: string;
  billingRate: number;
  laborCategoryId: number;
}

export class ContractLaborCategory {
  id: number;
  version: number;
  periodLength: number;
  locationType: string;
  description?: string;
  positionTitle?: string;
  positionDuties?: string;
  qualification?: string;
  customerCategory?: boolean;
  maxYearsExperience?: number;
  minYearsExperience?: number;
  laborCategoryCode: string;
  billingRate: number;
  noRateEscalation?: boolean;
  hourCeiling?: number;
  displayTotalHoursBilled?: number;
  contractId?: number;
  degreeRequiredId?: number;
  positionDescriptionId?: number;
  certificationRequiredId?: number;
  contractBidId?: number;
  contractModId?: number;
  degreeRequiredName?: string;
  certificationRequiredName?: string;
  // statusId: number;
  modNumber?: string;
}


export class Contract {
  id: number;
  version: number;
  subtype: ContractType;
  // chargeNumberPrefix: string;
  description?: string;
  basePeriodEndDate?: string;
  billingType: BillingType;
  revenueRecognitionType: RevenueRecognitionType;
  revenueRecognitionLevel: RevenueRecognitionLevel;
  revenueAccountGroupId?: number;
  businessSectorType: BusinessSectorType;
  lineOfBusinessId?: number;
  // revenueRecognitionType: string;
  contractTitle: string;
  contractNumber: string;
  //New changes
  currencyCodeId?: number; //confirm again
  templateContract?: boolean = false;
  masterContract?: boolean = false; //confirm again

  contractAccessFeePercent?: number;
  signedDate?: string;
  // -----------------
  awardDate?: string;
  // awardDate?: string;
  hasClins?: boolean = true;
  hasRetainageFee?: boolean = false;
  feeRetainagePercent ?: number;
  itdRetainageAmount ?: number;
  retainageInvoiceDate?: string;
  periodLength?: number; // labor period length

  expenseMarkupType?: string;

  pdfTemplateId?: number; //pdf template id;

  contractBillingPlanId?: number;
  contractBillingPlanName?: string;


  gandaPoolId?: number;
  materialHandlePoolId?: number;

  startDate?: string;
  endDate?: string;
  closeOutDate?: string;
  periodRevenue?: number;
  potentialValue?: number;
  revenueITD?: number;
  revenueYTD?: number;
  escalationRate?: number;
  managingObsId?: number;
  parentContractId?: number;
  previousContractId?: number;
  previousContractTitle?: string;

  customerId?: number;
  shipToAddressId?: number;
  billToAddressId?: number;
  contactId?: number;

  contractBidId?: number;
  purchaseOrderId?: number;
  purchaseOrderNumber?: string;
  parentContractTitle?: string;
  inheritedContractAccessFeePercent?: number;

  @Type(serializeType(Contract)) children?: Contract[];
  @Type(serializeType(ContractSla)) slas?: ContractSla[];
  comments?: ContractComment[];
  acctSettings?: ContractAccountSetting[];
  @Type(serializeType(ContractOption)) options?: ContractOption[];
  @Type(serializeType(InternalContact)) contacts?: InternalContact[];
  @Type(serializeType(ContractLaborCategory)) laborCategories?: ContractLaborCategory[];
  todoTasks?: any[];
  @Type(serializeType(ContractMilestone)) milestones?: ContractMilestone[];
  federalAgency?: string;
  // endDateWithAllOptions?: string;
  iffPayment?: boolean;
  casCovered?: boolean;
  competitiveAward?: boolean;
  itarRequired?: boolean;
  loeContract?: boolean;
  ociClauseInContract?: boolean;
  costPricingDataRequired?: boolean;
  ociMitigationPlanRequired?: boolean;
  smallBusinessPlanRequired?: boolean;
  disclosureStatementRequired?: boolean;
  hasOnerousTerms?: boolean;
  hasDpasRating?: boolean;
  dpasRating?: number;
  onerousTerms?: string;
  wageDeterminationId?: number;
  subjectToExecutiveOrder?: boolean;
  loeHours?: number;
  totalHoursUsed?: number;
  vendorId?: number;
  vendorBussinessName?: string;
  vendorStatusId?: number;
  vendorStatusName?: string;
  // Delegation
  submittedById?: number;
  submittedForId?: number;
  // Status
  currentStatusName?: ApprovalStatusType = ApprovalStatusType.NotAvailable;
  hasSubmissionError?: boolean;
  hasApproved?: boolean;
  useContractIndirectRates?: boolean;

  txnNumber?: number;     // contract number
}

export class ContractBidInfo {
  statusName: string;
  contractTitle: string;
  customerBusinessName: string;
  departmentName: string;
}


export class ContractBid {
  id: number;
  version: number;
  name: string;
  businessSectorType: string;
  description?: string;
  bidDate: string;
  goodUntilDate: string;
  startDate?: string;
  endDate?: string;
  basePeriodEndDate?: string;
  periodLength?: number; // labor period length
  feeRate: number;
  gandaRate: number;
  fringeRate: number;
  overheadRate: number;
  matHandlingRate: number;
  escalationRate: number;
  contractId?: number;
  totalValue?: number;
  obsId: number;
  currentStatusName?: ApprovalStatusType = ApprovalStatusType.NotAvailable;
  hasSubmissionError?: boolean;
  // statusId: number;
  gandaPoolId?: number;
  fringePoolId?: number;
  overheadPoolId?: number;
  matHandlingPoolId?: number;
  pdfTemplateId?: number;
  contractBidInfo?: ContractBidInfo = new ContractBidInfo();
  customerId?: number;
  laborCategories?: ContractLaborCategory[];
  txnNumber?: number;
}

export class BillingSchedule {
  id: number;
  version: number;
  memo?: string;
  invoicePeriodId: number;
  invoiced?: boolean;
  billingDate?: string;
  billingAmount?: number;
  contractMilestoneId?: number;
  projectMilestoneId?: number;
  contractMilestoneName?: string;
  projectMilestoneName?: string;
  contractMilestoneDate?: string;
  projectMilestoneDate?: string;
  invoicePeriodLabel?: string;
  billingPlanId: number;
}

export class MinimumBillingSchedule {
  id?: number;
  version?: number;
  revenueType: RevenueType;
  itemDescription: string;
  minimumHours: number;
  minimumAmount: number;
  orgId: number;
  billingPlanId: number;
  projectLaborCategoryId: number;
  projectTaskId: number;
  contractLaborCategoryId: number;
  laborCategoryTitle: string;
}

export enum MinimumBillingType {
  None = "NONE",
  LaborCategory = "LABOR_CATEGORY",
  FixedDollar = "FIXED_DOLLAR"

}

// export class ContractBillingPlan { //deprecated
//   id: number;
//   version: number;
//   name: string;
//   description?: string;
//   billingEmail: string;
//   billingMethodType: string;
//   billingFrequencyType: string;
//   billingLaborLevelType?: string;
//   billingStartOn: string;
//   billingDayOfMonth: string;
//   includeTravelDetail?: boolean;
//   includeMaterialDetail?: boolean;
//   allowManualAdjustment?: boolean;
//   @Type(serializeType(BillingSchedule)) billingSchedules: BillingSchedule[];
//   billingAddressId?: number;
//   addressName?: string;
//   detailAddress?: string;
//   statusId: number;

// }
export class BillingPlan {
  id: number;
  version: number;
  name: string;
  billingPlanType: string;
  description?: string;
  billingMethodType?: string;
  billingFrequencyType?: string;
  minimumBillingType: MinimumBillingType;
  billingLevelType: BillingLevelType;
  billingStartOn: string;
  billingDayOfMonth?: string;
  allowExpenseBilling?: boolean = false;
  invoiceFeeSeparately?: boolean = true;
  includeTimesheets?: boolean;
  includeActivityComments?: boolean;
  includeExpenseReports?: boolean;
  includeMaterialDetail?: boolean;
  includeUserActivityReport?: boolean;
  includeVendorInvoiceDetail?: boolean;
  transactionsToIncludeInInvoicePdfString?: string;
  transactionsToIncludeInInvoicePdf: Transaction[];

  excludeTravel?: boolean;
  excludeTraining?: boolean;
  excludeOdc?: boolean;
  excludeMaterial?: boolean;
  includeFormDD250?: boolean;
  includeForm1034?: boolean;
  allowManualAdjustment?: boolean;
  emailInvoice?: boolean;
  invoiceAmountOverCeiling?: boolean;
  purchasePDFTemplateId?: number;
  timesheetPDFTemplateId?: number;
  expensePDFTemplateId?: number;
  invoicePDFTemplateId?: number;
  userActivityPDFTemplateId?: number;
  formDD250TemplateId?: number;
  form1034TemplateId?: number;

  invoiceRemark?: string; // it would be displayed in the customer invoice

  @Type(serializeType(BillingSchedule)) billingSchedules: BillingSchedule[];
  @Type(serializeType(FeeSchedule)) feeSchedules: FeeSchedule[];
  @Type(serializeType(MinimumBillingSchedule)) minimumBillingSchedules: MinimumBillingSchedule[];
  // statusId: number;
  contractModId?: number;
  projectModId?: number;
  modNumber?: string;

  paymentTermsId?: number;
  paymentTermsName?: string;


}

export class BillingPlanSimple {
  id: number;
  name: string;
}


export class ContractModImpact {
  id: number;
  impacted: string;
  description: string;
  modifiedByUserFullName: string;
  modifiedOn: string;
  statusName: string;
}

export class ContractModImpactPanel {
  @Type(serializeType(ContractModImpact)) options: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) clins: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) clinFundings: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) optionFundings: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) slas: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) laborCategories: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) milestones: ContractModImpact[] = [];
  @Type(serializeType(ContractModImpact)) billingPlans: ContractModImpact[] = [];
}

export enum ContractEnumNames {
  ContractTypes = 'contract.type.ContractType',
  BusinessSectorTypes = 'contract.type.BusinessSectorType',
  RevenueTypes = 'contract.type.RevenueRecognitionType',
  BillingTypes = 'contract.type.BillingType',
  FundingTypes = 'contract.type.FundingType',
  // FeeTypes = 'contract.type.FeeType',
  // PriceTypes = 'contract.type.PriceType',

}

export enum ContractType {
  GovernmentPrime = 'GOVERNMENT_PRIME',
  GovernmentSubContract = 'GOVERNMENT_SUBCONTRACT',
  CommercialPrime = 'COMMERCIAL_PRIME',
  CommercialSubContract = 'COMMERCIAL_SUBCONTRACT',
  DeliveryOrder = 'DELIVERY_ORDER',
  SalesOrder = 'SALES_ORDER',
  TaskOrder = 'TASK_ORDER'
}

export enum DueDateType {
  DaysFromStart = 'DAYS_FROM_START',
  AbsoluteDate = 'ABSOLUTE_DATE'
}

export enum ContractEmit {
  AddSLA = 'SLA has been added.',
  UpdateSLA = 'SLA has been updated.',
  DeleteSLA = 'SLA has been deleted.',
  AddCLIN = 'CLIN has been added.',
  UpdateCLIN = 'CLIN has been updated.',
  DeleteCLIN = 'CLIN has been deleted.',
  AddOption = 'Option has been added.',
  UpdateOption = 'Option has been updated.',
  DeleteOption = 'Option has been deleted.',
  OptionFundingSaved = "Option funding has been saved.",
  OptionFundingUpdated = "Option funding has been updated.",
  ClinFundingAdded = "CLIN funding has been added.",
  ClinFundingUpdated = "CLIN funding has been updated.",
  ClinFundingDeleted = "CLIN funding has been deleted.",
  AddMilestone = 'Milestone has been added.',
  UpdateMilestone = 'Milestone has been updated.',
  DeleteMilestone = 'Milestone has been deleted.',
  MilestoneUp = 'Milestone Position has been shifted',
  MilestoneDown = 'Milestone Position has been shifted',
  AddLC = 'Labor Category has been added.',
  UpdateLC = 'Labor Category has been updated.',
  DeleteLC = 'Labor Category has been deleted.',
  AddMod = 'Modification has been added.',
  UpdateMod = 'Modification has been updated.',
  DeleteMod = 'Modification has been deleted.',
  SubmitMod = 'Modification has been submitted.',
  ContactSave = 'Contact has been saved.',
  ContactUpdate = 'Contact has been updated.',
  ContactDelete = 'Contact has been deleted.',
}

